import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Moment from 'moment';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import BookingIcon16 from '../../../16pxIcons/BookingIcon16';
import BookingsList, { BookingsListDataItem } from './BookingsList';
import GetBookingsList from '../../../../requests/Sensors/Occupancy/GetBookingsList';
import { DateRange } from '../../../../redux/dateRangeSlice';

interface BookingsByTimeProps {
  title: string,
  locationId: string,
}

const BookingsByTime = ({ title, locationId }: BookingsByTimeProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const [data, setData] = useState<BookingsListDataItem[] | undefined>(undefined);

  useEffect(() => {
    GetBookingsList({ locationId, range }).then((res) => {
      setData(res.map((item) => ({
        startTime: Moment(item.occurrenceStartDate).format('h a'),
        endTime: Moment(item.occurrenceEndDate).format('h a'),
        count: item.numberOfAttendees,
      })) ?? null);
    });
  }, [range, locationId]);

  return <SpaceUtilizationWidget
    title={title ?? 'Bookings'}
    tooltipText='Shows the number of room bookings made during each time period'
    icon={<BookingIcon16 />}
    content={<BookingsList {...{ data }} />}
  />;
};

export default BookingsByTime;
